let apiUrlTemp = "https://sf.easiio.cn"
if(window.origin.indexOf('sflow.io') > -1){
  apiUrlTemp = 'https://api.sflow.io'
}else if(window.origin.indexOf('sflow.pro') > -1){
  apiUrlTemp = 'https://api.sflow.pro'
}
else if (window.origin.indexOf('saasflow.cn') > -1) {
  apiUrlTemp = 'https://api.saasflow.cn'
// else if (window.origin.indexOf('localhost') > -1) {
//   apiUrlTemp = 'https://api.saasflow.cn'
}else{
  apiUrlTemp = "https://sf.easiio.cn"
}

export const apiUrl = apiUrlTemp